import { Link } from 'react-router-dom'
import { Menu } from '../../../componentes/menu'

export const Header = () => {
    return (
        <header className="bg-white pb-8">
            <div className="wrapper flex justify-between items-start ">
                <Link to="/">
                    <img
                        src="/assets/img/logo.png"
                        alt="lascuatroestacionesdelsabor"
                        className="max-w-28 md:max-w-48"
                    />
                </Link>
                <img
                    src="/assets/img/anio.png"
                    alt="Sabor del año"
                    className="max-w-20 md:max-w-36"
                />
                <Menu />
            </div>
        </header>
    )
}

/**
 * <div
            className={css`
                display: grid;
                grid-template-columns: 2fr 1fr;
                align-items: center;
                justify-content: space-between;
                gap: 2rem;
                padding: 1rem 0 2rem;
                background: black;
            `}>
            <Link
                to="/"
                className={css`
                    display: flex;
                    align-items: center;
                `}>
                <img
                    src="/assets/img/logo.png"
                    alt="lascuatroestacionesdelsabor"
                    className={css`
                        width: 100%;
                        max-width: 180px;
                    `}
                />
            </Link>
            <img
                src="/assets/img/anio.png"
                alt="Sabor del año"
                className={css`
                    width: 100%;
                    max-width: 100px;
                    justify-self: end;
                `}
            />
        </div>
 */
